<template>
  <div class="main">
    <a-form
      id="formLogin"
      class="user-layout-login"
    >
      <a-form-item>
        <a-input
          size="large"
          type="text"
          placeholder="账户"
          v-model="username"
        >
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-input
          size="large"
          type="password"
          autocomplete="false"
          placeholder="密码"
          v-model="password"
        >
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="loading"
          @click="login"
        >确定</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>

export default {
  layout: 'user',
  data () {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  methods: {
    async login () {
      if (!this.username || !this.password) {
        this.$notification['error']({
          message: '错误',
          description: '请填写账号和密码'
        })
        return
      }
      this.loading = true
      try {
        let res = await this.$tkParse.post('/login', {
          username: this.username,
          password: this.password
        })
        this.$tkParse.setSessionToken(res.data.sessionToken)
        let user = await this.$tkParse.getData('/users/me')
        if (user.status !== 'admin') {
          console.log('非后台管理员禁止登录')
          throw new Error('非后台管理员禁止登录')
        }
        this.$store.commit('setUser', user)
        this.$store.commit('setSessionToken', res.data.sessionToken)
        this.$router.push('/')
      } catch (e) {
        this.$notification['error']({
          message: '无法登录',
          description: '账号或密码错误'
        })
        this.$tkParse.setSessionToken(null)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-layout-login {
    label {
      font-size: 14px;
    }

    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
    }

    .user-login-other {
      text-align: left;
      margin-top: 24px;
      line-height: 22px;

      .item-icon {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }
</style>
